import { useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom-v5-compat";
import { experimentalStyled } from "@mui/material/styles";
import DashboardNavbar from "./DashboardNavbar";
import DashboardSidebar from "./DashboardSidebar";
import useAuth from "src/hooks/useAuth";
import { DuressProvider } from "src/components/duress/DuressProvider";
import { DuressBanner, DuressDrawer } from "src/components/duress/DuressChrome";
import DemoAccountTour from "src/components/demo/DemoAccountTour";

const DashboardLayoutRoot = experimentalStyled("div")(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  display: "flex",
  height: "100%",
  overflow: "hidden",
  width: "100%",
}));

const DashboardLayoutWrapper = experimentalStyled("div")(({ theme }) => ({
  display: "flex",
  flex: "1 1 auto",
  overflow: "hidden",
  paddingTop: "64px",
  flexDirection: "column",
  minWidth: 0,
  minHeight: 0,
}));

const DashboardLayoutContainer = experimentalStyled("div")({
  minHeight: 0,
  display: "flex",
  flex: "1 1 auto",
  overflow: "hidden",
});

const DashboardLayoutContent = experimentalStyled("div")({
  flex: "1 1 auto",
  height: "100%",
  overflow: "auto",
  position: "relative",
  WebkitOverflowScrolling: "touch",
});

const DashboardLayout = () => {
  const [isSidebarMobileOpen, setIsSidebarMobileOpen] = useState(false);

  const { user } = useAuth();
  const location = useLocation();
  const isTsAdmin = Boolean(user?.tsadmin);
  const normalizedPath = location.pathname.replace(/\/+$/, "");
  const isAllowedTsAdminPath = normalizedPath === "/dashboard/assets";

  if (isTsAdmin && !isAllowedTsAdminPath) {
    return <Navigate to="/dashboard/assets" replace />;
  }

  return (
    <DuressProvider key={`${user?.username_id}:${user?.companyid}`}>
      <DashboardLayoutRoot>
        <DashboardNavbar
          companyid={user?.companyid}
          onSidebarMobileOpen={() => setIsSidebarMobileOpen(true)}
        />
        <DashboardSidebar
          onMobileClose={() => setIsSidebarMobileOpen(false)}
          openMobile={isSidebarMobileOpen}
        />
        <DashboardLayoutWrapper>
          <DuressBanner />
          <DashboardLayoutContainer>
            <DashboardLayoutContent>
              <Outlet />
              <DemoAccountTour />
            </DashboardLayoutContent>
          </DashboardLayoutContainer>
        </DashboardLayoutWrapper>
        <DuressDrawer />
      </DashboardLayoutRoot>
    </DuressProvider>
  );
};

export default DashboardLayout;
